var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfiles = function SvgProfiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.634 9.059a1.515 1.515 0 0 0-.275 0 3.683 3.683 0 0 1-3.558-3.692c0-2.042 1.65-3.7 3.7-3.7a3.696 3.696 0 0 1 .133 7.392ZM13.675 3.333A2.915 2.915 0 0 1 16.59 6.25a2.92 2.92 0 0 1-2.808 2.916.942.942 0 0 0-.217 0M3.466 12.133c-2.017 1.35-2.017 3.55 0 4.892 2.291 1.533 6.05 1.533 8.341 0 2.017-1.35 2.017-3.55 0-4.892-2.283-1.525-6.041-1.525-8.341 0ZM15.281 16.667a4.031 4.031 0 0 0 1.634-.725c1.3-.975 1.3-2.583 0-3.558-.459-.35-1.017-.584-1.609-.717"
  })));
};
export default SvgProfiles;